// Services/Users/fetchSendOtp.js
import { USERS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

// Normaliza formas frecuentes de respuesta de tu interceptor/backend
const norm = (res) => {
  const statusCode =
    res?.statusCode ?? res?.code ?? res?.status ?? res?.body?.statusCode ?? null;

  const message =
    res?.message ??
    res?.body?.message ??
    res?.body?.error ??
    (statusCode === 200 ? "OTP enviado" : "Error");

  const data = res?.data ?? res?.body?.data ?? null;

  return { statusCode, message, data, raw: res };
};

export const fetchSendOtp = async ({ email }) => {
  const method = "POST";
  const res = await ApiRequestInterceptor(USERS.sendOtp, method, { email });
  const { statusCode, message, data, raw } = norm(res);

  switch (statusCode) {
    case 200:
      return { statusCode, message, data, ...raw };
    case 400:
      throw new Error(message || "Email requerido");
    case 404:
      throw new Error("Usuario no encontrado");
    case 409:
      throw new Error("El usuario ya está verificado");
    case 429: {
      // intenta extraer segundos si el backend manda "Espera 30s"
      const m = /\b(\d+)\s*s\b/i.exec(message || "");
      const secs = m ? Number(m[1]) : null;
      throw new Error(
        secs
          ? `Demasiadas solicitudes. Espera ${secs}s.`
          : "Demasiadas solicitudes. Intenta más tarde."
      );
    }
    default:
      throw new Error(message || "Error al enviar el código de verificación");
  }
};